import { LayerKey } from '@festina-life/api'
import { useMemo } from 'react'
import { useParams } from 'react-router'

import { NO_LAYER_PATH, SHARED_TENANT_PATH } from './constants'

export const useLayer = () => {
  const { tenantId, layerId } = useParams<{
    tenantId: string
    layerId: string
  }>()

  const resolvedLayerId = layerId && layerId !== NO_LAYER_PATH ? layerId : null
  const resolvedTenantId =
    tenantId && tenantId !== SHARED_TENANT_PATH ? tenantId : null

  return useMemo(
    () =>
      new LayerKey({ layerId: resolvedLayerId, tenantId: resolvedTenantId }),
    [resolvedLayerId, resolvedTenantId],
  )
}
